import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const Drawer = ({ children, className, open, tag: Tag, ...props }) => (
  <Tag className={classnames(className, 'drawer', { open })} data-testid="Drawer" {...props}>
    {children}
  </Tag>
);

Drawer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  open: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

Drawer.defaultProps = {
  children: null,
  className: null,
  open: false,
  tag: 'div',
};

export default Drawer;
